import React from "react";

import Icon from "../Icon";

/**
 * Linha de um grupo que o plano ainda não libera: mesma cara do Group, sem
 * sanfona. O `trail` (selo de "em breve", cadeado) ocupa o lugar da seta; com
 * `onClick` a linha vira botão, sem ele é só informativa.
 */
export const PlaceholderGroup = ({ placeholder, icon }) => {
    const content = (
        <>
            <Icon name={icon ?? 'link'} size={15} />
            <span className="linked-group-name">{placeholder.label}</span>
            {placeholder.trail}
        </>
    );

    return (
        <section className="linked-group is-placeholder">
            {placeholder.onClick ? (
                <button type="button" className="linked-group-head" onClick={placeholder.onClick} aria-label={`${placeholder.label}: ${placeholder.hint}`}>
                    {content}
                </button>
            ) : (
                <div className="linked-group-head" aria-label={`${placeholder.label}: ${placeholder.hint}`}>
                    {content}
                </div>
            )}
        </section>
    );
};

export default PlaceholderGroup;
